import styled from 'styled-components';
import {
  List,
  Input as SemanticInput,
  Dropdown as SemanticDropdown,
  Divider as SemanticDivider,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Header, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  margin-top: 30px;
`;

export const ElementForm = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const Section = styled.div`
  margin-bottom: 20px;
`;

export const Title = styled(TextLayoutComponent)`
  font-size: 16px;
  margin-bottom: 15px;
  color: #192c47;
  font-family: 'Roboto';
  font-weight: 400;
`;

export const ErrorMessage = styled(TextLayoutComponent.Error)`
  ${({ bold }) => bold && `
    font-weight: 500;
  `}
`;

export const Input = styled(SemanticInput)`
  width: 400px;
  margin-right: 20px;
`;

export const MessageContainer = styled.div`
  display: inline-block;
  margin-left: 20px;
  width: fit-content;
  margin-top: 5px;
`;

export const Link = styled.a`
  ${({ hasMarginTop }) => hasMarginTop && `
    margin-top: 20px;
  `}
`;

export const Divider = styled(SemanticDivider)`
  &.ui.divider {
    border-top: 1px solid #EDEDED;
    margin-top: 5px;
  }
`;

export const Dropdown = styled(SemanticDropdown)`
  &.ui.dropdown {
    min-width: 100px;
    width: 300px;
  }
`;

export const DangerMsg = styled(Header.Danger)``;

export const ContainerList = styled(List)``;

export const ItemList = styled(List.Item)``;

export const TextList = styled(TextLayoutComponent)``;

export const DangerButton = styled(ButtonLayoutComponent.Danger)``;

export const SaveButton = styled(ButtonLayoutComponent)`
  align-self: flex-end;
  width: 80px;
  @media (min-width: 320px) and (max-width: 767px) {
    margin-top: 20px !important;
  }
`;
